<template>
  <div class="admin-inspection-task-detail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('adminInspectionTaskDetail.page.title')"
      :subtitle="$t('adminInspectionTaskDetail.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- 任务信息面板 -->
    <div class="ds-panel ds-panel--detail" v-loading="loading">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('adminInspectionTaskDetail.title') }}</span>
      </div>
      <div class="ds-panel__body">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('adminInspectionTaskDetail.taskId') }}</div>
              <div class="ds-field__value ds-num">{{ adminInspectionTaskDetailInfo.taskId || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('adminInspectionTaskDetail.inspectionPlanName') }}</div>
              <div class="ds-field__value">{{ adminInspectionTaskDetailInfo.inspectionPlanName || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('adminInspectionTaskDetail.planTime') }}</div>
              <div class="ds-field__value ds-num">
                <div class="ds-time-cell">
                  <span>{{ adminInspectionTaskDetailInfo.planInsTime || '-' }}</span>
                  <span>{{ adminInspectionTaskDetailInfo.planEndTime || '-' }}</span>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('adminInspectionTaskDetail.actInsTime') }}</div>
              <div class="ds-field__value ds-num">{{ adminInspectionTaskDetailInfo.actInsTime || '-' }}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('adminInspectionTaskDetail.originalPlanUser') }}</div>
              <div class="ds-field__value">{{ adminInspectionTaskDetailInfo.originalPlanUserName || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('adminInspectionTaskDetail.currentPlanUser') }}</div>
              <div class="ds-field__value">{{ adminInspectionTaskDetailInfo.planUserName || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('adminInspectionTaskDetail.transferDesc') }}</div>
              <div class="ds-field__value">{{ adminInspectionTaskDetailInfo.transferDesc || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('adminInspectionTaskDetail.signType') }}</div>
              <div class="ds-field__value">{{ adminInspectionTaskDetailInfo.signTypeName || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('adminInspectionTaskDetail.state') }}</div>
              <div class="ds-field__value">
                <ds-status-tag :type="resolveState" :label="adminInspectionTaskDetailInfo.stateName || '-'" />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 标签页面板 -->
    <div class="ds-panel ds-panel--tabs">
      <el-tabs v-model="adminInspectionTaskDetailInfo._currentTab"
        @tab-click="handleTabClick(adminInspectionTaskDetailInfo._currentTab)">
        <el-tab-pane :label="$t('adminInspectionTaskDetail.tab.detail')" name="adminPointTaskDetail">
          <admin-point-task-detail ref="adminPointTaskDetail" />
        </el-tab-pane>
        <el-tab-pane :label="$t('adminInspectionTaskDetail.tab.map')" name="aInspectionTaskMap">
          <a-inspection-task-map ref="aInspectionTaskMap" />
        </el-tab-pane>
        <el-tab-pane :label="$t('adminInspectionTaskDetail.tab.plan')" name="adminRoutePlan">
          <admin-route-plan ref="adminRoutePlan" />
        </el-tab-pane>
        <el-tab-pane :label="$t('adminInspectionTaskDetail.tab.route')" name="adminPointRoute">
          <admin-point-route ref="adminPointRoute" />
        </el-tab-pane>
        <el-tab-pane :label="$t('adminInspectionTaskDetail.tab.point')" name="aInspectionRoutePoint">
          <a-inspection-route-point ref="aInspectionRoutePoint" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import AdminPointTaskDetail from '@/components/inspection/AdminPointTaskDetail'
import AInspectionTaskMap from '@/components/inspection/AInspectionTaskMap'
import AdminRoutePlan from '@/components/inspection/AdminRoutePlan'
import AdminPointRoute from '@/components/inspection/AdminPointRoute'
import AInspectionRoutePoint from '@/components/inspection/AInspectionRoutePoint'
import { getAdminInspectionTaskDetail } from '@/api/inspection/adminInspectionTaskDetailApi'
import { resolveStatus } from '@/utils/statusMap'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'AdminInspectionTaskDetailList',
  components: {
    AdminPointTaskDetail,
    AInspectionTaskMap,
    AdminRoutePlan,
    AdminPointRoute,
    AInspectionRoutePoint,
    DsPageHeader,
    DsStatusTag
  },
  data() {
    return {
      loading: false,
      adminInspectionTaskDetailInfo: {
        inspectionPlanId: '',
        inspectionPlanName: '',
        originalPlanUserId: '',
        originalPlanUserName: '',
        planEndTime: '',
        planInsTime: '',
        planUserId: '',
        planUserName: '',
        signType: '',
        signTypeName: '',
        state: '',
        stateName: '',
        taskId: '',
        taskType: '',
        inspectionRouteId: '',
        total: 0,
        records: 1,
        moreCondition: false,
        inspectionName: '',
        pointObjTypes: [],
        _currentTab: 'adminPointTaskDetail'
      }
    }
  },
  computed: {
    /**
     * 巡检任务状态语义标签（inspection_task 域）
     */
    resolveState() {
      const resolved = resolveStatus(this.adminInspectionTaskDetailInfo.state, {
        domain: 'inspectionTask',
        text: this.adminInspectionTaskDetailInfo.stateName || '',
        fallbackLabel: this.adminInspectionTaskDetailInfo.stateName || ''
      })
      return resolved.type
    }
  },
  created() {
    this.adminInspectionTaskDetailInfo.taskId = this.$route.query.taskId
    this.loadAdminInspectionTaskDetail()
  },
  methods: {
    async loadAdminInspectionTaskDetail() {
      try {
        this.loading = true
        const params = {
          page: 1,
          row: 1,
          taskId: this.adminInspectionTaskDetailInfo.taskId
        }
        const { inspectionTasks } = await getAdminInspectionTaskDetail(params)
        Object.assign(this.adminInspectionTaskDetailInfo, inspectionTasks[0])
        this.handleTabClick(this.adminInspectionTaskDetailInfo._currentTab)
      } catch (error) {
        console.error('获取巡检任务详情失败:', error)
        this.$message.error(this.$t('common.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleTabClick(tab) {
      this.adminInspectionTaskDetailInfo._currentTab = tab
      setTimeout(() => {
        if (this.$refs[tab]) {
          this.$refs[tab].loadData({
            taskId: this.adminInspectionTaskDetailInfo.taskId,
            inspectionPlanId: this.adminInspectionTaskDetailInfo.inspectionPlanId,
            inspectionRouteId: this.adminInspectionTaskDetailInfo.inspectionRouteId
          })
        }
      }, 500)
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push({ path: '/pages/property/adminInspectionTask' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-inspection-task-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-md);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--ds-spacing-sm);
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    background: var(--ds-gray-100);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }

  &__body {
    padding: var(--ds-spacing-lg);
  }
}

/* 详情字段 */
.ds-field {
  margin-bottom: var(--ds-spacing-md);

  &__label {
    font-size: var(--ds-font-size-xs);
    color: var(--ds-gray-500);
    margin-bottom: var(--ds-spacing-xs);
  }

  &__value {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-800);
    line-height: 1.6;
    word-break: break-all;
  }
}

/* 起止时间上下两行 */
.ds-time-cell {
  display: flex;
  flex-direction: column;
  line-height: 1.6;

  span {
    font-size: var(--ds-font-size-xs);
  }
}
</style>
